import type { User } from '@/types/auth';

/**
 * A user's full name, or '' when neither part is set. Some accounts arrive with
 * no name (e.g. an OAuth provider that didn't share one), so every place that
 * shows a name must handle the empty case rather than render blank/awkward
 * fragments like "Booking as  (email)".
 */
export function userFullName(u: Pick<User, 'first_name' | 'last_name'>): string {
  return [u.first_name, u.last_name]
    .map((s) => s?.trim())
    .filter(Boolean)
    .join(' ');
}
